import dynamic from 'next/dynamic';

export const SearchKimRatingDynamic = dynamic(
  () =>
    import(/* webpackChunkName: 'SearchKimRating' */ './SearchKimRating').then(
      (mod) => mod.SearchKimRating,
    ),
  { ssr: false },
);
